export function useTableData(data, columnsConfig = {}) {
  const validRows = data.filter((item) => item && typeof item === 'object')

  const getColumns = (item) => {
    if (!item) return []

    const allItemKeys = Object.keys(item)

    const columnObjects = allItemKeys.map((key) => {
      const column = {
        key,
        title: key,
        visible: true,
        sortable: false,
      }

      if (columnsConfig[key]) {
        const config = columnsConfig[key]
        if (
          typeof config === 'object' && config !== null && !Array.isArray(config)
        ) {
          Object.assign(column, config)
        } else {
          column.title = config
        }
      }

      return column
    })

    const withPosition = columnObjects.filter(
      (col) => col.position !== undefined
    )
    const configuredNoPosition = columnObjects.filter(
      (col) => col.position === undefined && columnsConfig[col.key] !== undefined
    )
    const unconfigured = columnObjects.filter(
      (col) => col.position === undefined && columnsConfig[col.key] === undefined
    )

    withPosition.sort((a, b) => a.position - b.position)

    const orderedColumns = [
      ...withPosition,
      ...configuredNoPosition,
      ...unconfigured,
    ]

    return orderedColumns.filter((column) => column.visible !== false)
  }

  const columns = validRows.length > 0 ? getColumns(validRows[0]) : []

  return { columns, validRows }
}
